module.exports = __webpack_public_path__ + "static/living-locally-db24c0fb65ff21a2dced2eac557effcc.jpg";